import { BRAND } from "@neus/shared";
import { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { MAIN_NAV, PHONE_HREF } from "../../nav";
import { CloseIcon } from "../Icons";
import styles from "./Layout.module.css";

export function MobileDrawer({ open, onClose }: { open: boolean; onClose: () => void }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  return (
    <>
      <div className={`${styles.drawerBackdrop} ${open ? styles.drawerOpen : ""}`} onClick={onClose} aria-hidden />
      <aside className={`${styles.drawer} ${open ? styles.drawerOpen : ""}`} aria-label="Menu" aria-hidden={!open}>
        <button
          type="button"
          className={styles.drawerClose}
          onClick={onClose}
          aria-label="Close menu"
          title="Close menu"
        >
          <CloseIcon alt="Close" />
        </button>
        <nav>
          <ul>
            {MAIN_NAV.map((item) => (
              <li key={item.label}>
                <NavLink to={item.to} end={item.to === "/"}>
                  {item.label}
                </NavLink>
                {item.children && (
                  <ul>
                    {item.children.map((c) => (
                      <li key={c.to}>
                        <NavLink to={c.to}>{c.label}</NavLink>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
            <li>
              <NavLink to="/cart">Cart</NavLink>
            </li>
          </ul>
        </nav>
        <div className={styles.drawerFooter}>
          {BRAND.shops.slice(1).map((s) => (
            <a key={s.label} href={s.href} target="_blank" rel="noreferrer">
              {s.label}
            </a>
          ))}
          <a href={PHONE_HREF}>{BRAND.phone}</a>
        </div>
      </aside>
    </>
  );
}
